import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { testimonials } from '../../enhancedMock';

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="fade-in-section py-12 md:py-20 px-4 bg-gradient-to-b from-white/80 to-warmBeige/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">What Our Patients Say</h2>
        <p className="text-sm md:text-xl text-gray-600">Real stories from people we've helped</p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-8">
        {testimonials.map((testimonial) => (
          <Card key={testimonial.id} className="border-none shadow-xl bg-white hover:shadow-2xl transition-all">
            <CardContent className="p-4 md:pt-6 md:p-6">
              <div className="flex items-center gap-1 mb-3 md:mb-4">
                {[...Array(testimonial.rating)].map((_, starIndex) => (
                  <Star key={`${testimonial.id}-star-${starIndex}`} className="fill-primaryOrange text-primaryOrange" size={16} />
                ))}
              </div>
              <p className="text-sm md:text-lg text-gray-700 italic mb-4 md:mb-6">"{testimonial.text}"</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-darkBrown text-sm md:text-base">{testimonial.name}</p>
                  <p className="text-xs md:text-sm text-gray-500">{testimonial.location}</p>
                </div>
                <div className="text-right">
                  <p className="text-xs md:text-sm font-semibold text-primaryOrange">{testimonial.service}</p>
                  <p className="text-xs text-gray-400">{testimonial.date}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
